import { GridColumn } from "@progress/kendo-react-grid";
import { Switch, SwitchChangeEvent } from "@progress/kendo-react-inputs";
import { GridFilterCellProps } from "@progress/kendo-react-grid"
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { protectedResources } from '../../authConfig';
import { BaseGrid, ButtonHelper } from '../../components/KendoGrid/BaseGrid';
import { useFetchWithMsal } from "../../hooks/useFetchWithMsal";
import { Kit, kitSizes, padKitNumber, padLotNumber } from "../../models/kit";
import { NoCommaNumericFilterCell, ZeroPaddedNumericFilterCell } from "../../components/KendoGrid/NumericFilterCell";
import { DropdownFilterCell } from "../../components/KendoGrid/DropDownFilterCell";
import { AppUserContext } from '../../components/PvsContextProvider';
import { useNotificationAPI } from '../../components/NotificationProvider';

const KitAdminList = () => {
    const { isLoading, execute } = useFetchWithMsal({
        scopes: protectedResources.scopes.admin
    });
    const appUserContext = useContext(AppUserContext);
    const { addNotification } = useNotificationAPI();

    const createNotificationMessage = (kit: Kit, message: string) => {
        const kitSize = kit.KitSize as any;
        addNotification(padLotNumber(kit.LotNumber) + "-" + kitSizes[kitSize].shortText + "-" + padKitNumber(kit.KitNumber) + " was toggled to " + message, 'Barcode List', "success");
        ;
    }

    const handleSubmit = (kit: Kit, thenFunction: Function) => {
        execute('PUT', protectedResources.apiKit.endpoint + "UpdateKit", kit)
            .then((data: any) => {
                if (data?.id) {
                    thenFunction();
                }
            });
    };

    const UsedCell = (kit: any) => {
        const toggleUsedCell = (e: SwitchChangeEvent) => {
            var updatedKit = {
                Id: kit.dataItem.id,
                LotNumber: kit.dataItem.lotNumber,
                KitSize: kit.dataItem.kitSize,
                KitNumber: kit.dataItem.kitNumber,
                ExpirationDate: kit.dataItem.expirationDate,
                Used: e.value,
                Flag: kit.dataItem.flag,
            } as Kit;

            kit.dataItem.used = e.value;

            handleSubmit(updatedKit, () => {
                createNotificationMessage(updatedKit, (updatedKit.Used ? "Used" : "Unused"));
            });
        }

        return <td>
            <Switch disabled={isLoading || appUserContext.isReadOnly} checked={kit.dataItem?.used} onLabel={"True"} offLabel={"False"} onChange={toggleUsedCell}></Switch>
        </td>
    }

    const FlagCell = (kit: any) => {
        const toggleFlagCell = (e: SwitchChangeEvent) => {
            var updatedKit = {
                Id: kit.dataItem.id,
                LotNumber: kit.dataItem.lotNumber,
                KitSize: kit.dataItem.kitSize,
                KitNumber: kit.dataItem.kitNumber,
                ExpirationDate: kit.dataItem.expirationDate,
                Used: kit.dataItem.used,
                Flag: e.value,
            } as Kit;

            kit.dataItem.flag = e.value;

            handleSubmit(updatedKit, () => {
                createNotificationMessage(updatedKit, (updatedKit.Flag ? "Flagged" : "Not Flagged"));
            });
        }

        return <td>
            <Switch disabled={isLoading || appUserContext.isReadOnly} checked={kit.dataItem?.flag} onLabel={"True"} offLabel={"False"} onChange={toggleFlagCell}></Switch>
        </td>
    }

    const DateCell = (kit: any) => {
        var date = new Date(kit.dataItem.expirationDate);
        return <td>
            {date.toLocaleDateString()}
        </td>;
    }

    const LotNumberCell = (kit: any) => {
        return <td>
            {padLotNumber(kit.dataItem.lotNumber)}
        </td>;
    }
    const KitNumberCell = (kit: any) => {
        return <td>
            {padKitNumber(kit.dataItem.kitNumber)}
        </td>;
    }

    const KitSizeCell = (kit: any) => {
        return <td>
            {kitSizes[kit.dataItem?.kitSize] ?
                kitSizes[kit.dataItem?.kitSize].text :
                "Unknown Size"}
        </td>;
    }
    const UsedFilterCell = (props: any) => (
        <DropdownFilterCell
            {...props}
            data={[{ name: "Used", id: "true" }, { name: "Unused", id: "false" }]}
            defaultItem={""}
            textField={"name"}
        />
    );
    const FlagFilterCell = (props: any) => (
        <DropdownFilterCell
            {...props}
            data={[{ name: "Flagged", id: "true" }, { name: "Not Flagged", id: "false" }]}
            defaultItem={""}
            textField={"name"}
        />
    );
    const navigate = useNavigate();

    const excelFunction = (kit: any) => {
        var date = new Date(kit.expirationDate);
        if (kit.expirationDate !== null) {
            kit.expirationDate = date.toLocaleDateString()
        }

        if (kit.kitSize !== undefined) {
            kit.kitSize = kitSizes[kit.kitSize] ? kitSizes[kit.kitSize].text : "Unknown Size"
        }

        return kit
    }

    const buttonList = appUserContext.isReadOnly ? undefined :
        [{ onClick: () => { { navigate("/barcode-import"); } }, buttonText: 'Import Barcodes' } as ButtonHelper];

    const KitSizeFilterCell = (props: GridFilterCellProps) => {
        const filters = [
            { id: 1, name: "10-200ul" },
            { id: 2, name: "201-5000ul" }] as any[];

        return <DropdownFilterCell
            {...props}
            data={filters}
            defaultItem={""}
            textField={"name"}
        />
    }

    return (
        <BaseGrid verb={'POST'} pageTitle='Barcode List' endpoint={protectedResources.apiKit.endpoint + "KendoGridRead"}
            button={buttonList} excelFunction={excelFunction}>
            <GridColumn field="lotNumber" cell={LotNumberCell} filterCell={NoCommaNumericFilterCell} filter="numeric" title="Lot Number" />
            <GridColumn field="kitSize" cell={KitSizeCell} title="Kit Size" filterCell={KitSizeFilterCell} />
            <GridColumn field="kitNumber" cell={KitNumberCell} filterCell={ZeroPaddedNumericFilterCell} filter="numeric" title="Kit Number" />
            <GridColumn field="expirationDate" cell={DateCell} filter="date" title="Expiration Date" />
            <GridColumn field="used" cell={UsedCell} title="Used" filterCell={UsedFilterCell} />
            <GridColumn field="flag" cell={FlagCell} title="Flag" filterCell={FlagFilterCell} />
        </BaseGrid>
    );
}

export default KitAdminList;